import OrderJobModel from "@/models/OrderJobModel";
import ServiceJobOperationModel from "@/models/ServiceJobOperationModel";

export default class OrderJobViewModel extends OrderJobModel {
	constructor(data?: any) {
		super(data);
		if (data) {
			this.vmId = data.vmId ?? 0;
			this.cost = data.cost ?? 0;

			if (data.availableOperations?.length) {
				this.availableOperations = data.availableOperations.map((_: any) => new ServiceJobOperationModel(_));
			}

			if (data.isOverriddingCostPerHour) {
				this.isOverriddingCostPerHour = true;
			}

			if (data.overriddenJobCostPerHour) {
				this.isOverriddingCostPerHour = true;
				this.overriddenJobCostPerHour = data.overriddenJobCostPerHour;
			}

			if (data.jobExpanded === true) {
				this.jobExpanded = true;
			}
		}
	}

	vmId = 0;
	cost = 0;

	isOverriddingCostPerHour = false;
	estimationHrsInvalid = false;
	assigneesInvalid = false;
	jobExpanded = false;
	availableOperations: Array<ServiceJobOperationModel> | null = null;
}